import React, { useEffect, useRef, useState } from 'react';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';

function AlertSearchBar({ searchPlaceholder = 'Search Rx #', onSearch, clearTrigger, label, value = '' }) {
    const [searchValue, setSearchValue] = useState(value);

    useEffect(() => {
        setSearchValue(value);
    }, [value]);

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setSearchValue('');
    }, [clearTrigger]);

    const handleSearch = () => {
        if (onSearch) {
            onSearch(searchValue);
        }
    };

    const handleClear = () => {
        setSearchValue('');
        if (onSearch) {
            onSearch('');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div
            style={{
                gap: 4,
            }}
            className=" d-flex align-items-center ">
            <label className="mb-0 font-weight-medium text-dark " style={{ fontSize: '16px', marginRight: '4px' }}>
                {label}:
            </label>
            <InputGroup style={{ width:"45%" }}>
                <Input
                    type="text"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={searchPlaceholder}
                />
                {searchValue && (
                    <InputGroupAddon addonType="append">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={handleClear}
                            style={{ cursor: 'pointer', border: '1px solid #b1b1b1' }}>
                            <FaTimes />
                        </button>
                    </InputGroupAddon>
                )}
                <InputGroupAddon addonType="append">
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleSearch}
                        style={{ cursor: 'pointer' }}>
                        <FaSearch />
                    </button>
                </InputGroupAddon>
            </InputGroup>
        </div>
    );
}

export default AlertSearchBar;
